/**
 * WhatsApp Embedded Signup Flow Utility
 * Handles generation of the Meta Onboarding URL (v25.0 Hosted ES)
 */

export const getWhatsAppOnboardUrl = (appId, configId, isCoexistence = false) => {
    const extras = {
        setup: {
            solution_id: '722513957493714'
        },
        feature: 'whatsapp_embedded_signup',
        session_info_version: 2,
        sessionInfoVersion: 2,
        features: [
            { name: 'app_only_install' },
            { name: 'marketing_messages_lite' }
        ],
        is_hosted_es: true
    };

    if (isCoexistence) {
        extras.featureType = 'whatsapp_business_app_onboarding';
    }

    const extrasStr = JSON.stringify(extras);
    const encodedExtras = encodeURIComponent(extrasStr);

    // Callback URL pointing back to our application (dynamic based on current origin)
    const callbackUrl = `${window.location.origin}/whatsapp-callback`;
    const encodedCallback = encodeURIComponent(callbackUrl);

    const scope = [
        'whatsapp_business_management',
        'whatsapp_business_messaging',
        'public_profile'
    ].join(',');

    // Added auth_type=rerequest to ensure new permissions are prompted
    return `https://www.facebook.com/v22.0/dialog/oauth?auth_type=rerequest&client_id=${appId}&config_id=${configId}&display=popup&extras=${encodedExtras}&redirect_uri=${encodedCallback}&response_type=code&scope=${scope}`;
};

export const launchWhatsAppSignupPopup = (appId, configId) => {
    const url = getWhatsAppOnboardUrl(appId, configId);

    const width = 600;
    const height = 700;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;

    return window.open(
        url,
        'WhatsAppOnboarding',
        `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );
};
